import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material';
import { Injectable } from '@angular/core';

import { AppMessageComponent } from './app-message.component';
import { take } from 'rxjs/operators';

interface confirmData {
  message?: string,
  type?: number
}

@Injectable()
export class AppMessageService {

  constructor(private _matDialog: MatDialog) { }

  public open(data:confirmData = {}): Observable<boolean> {
    data.message = data.message || '¿Estas seguro?';
    let dialogRef: MatDialogRef<AppMessageComponent>;
    dialogRef = this._matDialog.open(AppMessageComponent, {
      disableClose: true,
      data: { message: data.message, type: data.type }
    });
    return dialogRef.afterClosed().pipe(take(1));
  } 
}